import { scoreDebts } from 'constants/creditScore'
import React from 'react'
import { moneyFormat, toTitleCase } from 'utils'

const TableCreditScore = ({ data, className }) => {
  const handleOrder = () => {
    const dataOrder = data
    dataOrder.sort((a, b) => b.position - a.position)
    return dataOrder
  }
  return (
    <table
      className={`text-white w-full px-3 py-2 text-xs font-bold leading-tight border-separate border-spacing-y-2 ${className}`}
    >
      <thead>
        <tr className='bg-gray-900 h-9'>
          <th className='rounded-l-lg'>Institución</th>
          <th>Monto</th>
          <th className='rounded-r-lg'>Días de atraso</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          handleOrder().map((institution) => {
            const {
              amount,
              entity_arrears_days_interval: days_late,
              entity_name,
              entity_code,
              position
            } = institution
            return (
              <tr
                key={entity_code}
                className='text-xs h-12 text-center font-normal text-black bg-white '
              >
                <td
                  className={`px-5 text-left rounded-t-lg rounded-bl-sm truncate max-w-0 ${scoreDebts[position]}  `}
                >
                  {toTitleCase(entity_name)}
                </td>
                <td className={`${scoreDebts[position]} font-manrope text-xs`}>
                  {moneyFormat(amount)}
                </td>
                <td
                  className={`rounded-t-lg rounded-br-sm ${scoreDebts[position]} `}
                >
                  {days_late}
                </td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export default TableCreditScore
